<template>
  <div class="websocket">
    <el-button @click="disConn">断开</el-button>
    <el-button @click="openConn">开启</el-button>
  </div>
</template>

<script>
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import S from '@/utils/website'
import { getToken } from '@/utils/auth';
export default {
  name: 'websocket',
  components: {},
  data() {
    return {
      Authorization: '',
      stompClient: ''
    };
  },
  methods: {
    initWebSocket() {
      this.connection();
    },
    connection() {
      let headers = {
        Authorization: getToken()
      };
      let url = S.host.WS_URL+'/svolt-ess-service/cloud-websocket?topic=emsdatav2&access_token=' + headers.Authorization;
      let socket = new WebSocket(url);
      this.stompClient = Stomp.over(socket);

      this.stompClient.connect(
        headers,
        () => {
          //订阅服务端提供的接口
          console.log('进来了');
          this.stompClient.subscribe(
            '/topic/app/2-23304-190828-00004/CBa.BMS1.Summary.MaxSOH1',
            msg => {
              console.log('数据。。。', JSON.parse(msg.body));
            },
            headers
          );
          // this.stompClient.send('/app/chat.addUser', headers, JSON.stringify({ sender: '', chatType: 'JOIN' }));
        },
        err => {
          console.log('失败', err);
          //重新连接
        }
      );
    },
    //获取数据
    getData() {},
    //断开连接
    disconnect() {
      if (this.stompClient) {
        this.stompClient.disconnect();
      }
    },
    //测试断掉socket链接
    disConn(){
      this.COMM.disConnect();
    },
    //测试socket链接
    openConn(){
      let url = '/topic/app/2-23304-190828-00004/CBa.BMS1.Summary.MaxSOH1';
      this.COMM.initWebSocket(url, function(body) {
        console.log(body, '返回了结果');
      });
    }
  },
  watch: {},
  mounted() {},
  created() {
    // this.initWebSocket();
  }
};
</script>

<style lang="scss" scoped>
.websocket {
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/history-data/websocket.vue